import type { DomainDocumentItem } from "../api/types";

const REPORTS_FOLDER_NAME = "reports";
const DOCUMENTS_FOLDER_NAME = "documents";

export type DocumentTreeNode = {
	item: DomainDocumentItem;
	children: DocumentTreeNode[];
};

/** Items whose parent is missing from the list become roots. */
export function buildDocumentTree(
	documents: DomainDocumentItem[],
): DocumentTreeNode[] {
	const nodesById = new Map<number, DocumentTreeNode>(
		documents.map((item) => [item.id, { item, children: [] }]),
	);
	const roots: DocumentTreeNode[] = [];

	for (const node of nodesById.values()) {
		const parent =
			node.item.parentId == null
				? undefined
				: nodesById.get(node.item.parentId);
		if (parent) {
			parent.children.push(node);
		} else {
			roots.push(node);
		}
	}

	return roots;
}

/**
 * The Reports → Documents folder is the root of the report tree, as in eox7's
 * `findReportsRoot` (packages/report/src/features/document/reportsFolders.ts).
 */
export function findReportsRoot(
	tree: DocumentTreeNode[],
): DocumentTreeNode | null {
	const reportsNode = tree.find(
		(node) => node.item.name.toLowerCase() === REPORTS_FOLDER_NAME,
	);
	if (!reportsNode) return null;
	return (
		reportsNode.children.find(
			(child) => child.item.name.toLowerCase() === DOCUMENTS_FOLDER_NAME,
		) ?? null
	);
}
